module.exports = __webpack_public_path__ + "img/usa-digestive-diseases-female.70f60f2a.png";